import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hasPermission } from "../../layout/Constants";
import { useHistory } from "react-router-dom";

import Header from "../../../components/common/Header";
import useDataTable from "../../../components/common/DataTable";
import useNotification from "../../../components/common/ResultNotifier";
import AssetLocationActionView from "../../../components/common/ActionMenu";

import { exportRequest } from "../../../api/network/axios/exportRequest";
import {
  fetchAllAssetLocation,
  fetchAssetLocation,
  deleteAssetLocation,
} from "../../../api/redux/action/AssetLocationActions";

const AssetLocation = () => {
  const [searchText, setSearchText] = useState();
  const [exportAllLoading, setExportAllLoading] = useState(false);
  const [flattenedAllData, setFlattenedAllData] = useState([]);
  const [dataTable, setDataTable] = useState();
  const [sortedInfo, setSortedInfo] = useState({
    columnKey: null,
    order: null,
  });

  let history = useHistory();
  const dispatch = useDispatch();

  const {
    user,
    assetLocations,
    loading,
    requestStatus,
    error,
    allAssetLocation,
    language,
    englishLang,
    selectedTenant,
  } = useSelector((store) => ({
    user: store.authReducer.user,
    assetLocations: store.assetLocationReducer.assetLocations,
    loading: store.assetLocationReducer.loading,
    requestStatus: store.assetLocationReducer.requestStatus,
    error: store.assetLocationReducer.error,
    loading: store.assetLocationReducer.loading,
    user: store.authReducer.user,
    language: store.langReducer.language,
    allAssetLocation: store.assetLocationReducer.allAssetLocation,
    englishLang: store.langReducer.englishLang,
    selectedTenant: store.authReducer.selectedTenant,
  }));
  const columns = [
    {
      title:
        language?.ASSET_LOCATION?.value ?? englishLang?.ASSET_LOCATION?.value,
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortField: "name",
      sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
      render: (name) => (
        <a
          onClick={() => {
            const viewOption = "disabled";

            history.push({
              pathname: "/update-assetLocation",
              state: { selectedRow, viewOption },
            });
          }}
        >
          {name}
        </a>
      ),
    },
  ];

  const [allowPermission, setAllowPermission] = useState({
    edit: hasPermission(selectedTenant, "UPDATE_ASSET_LOCATIONS"),
    delete: hasPermission(selectedTenant, "DELETE_ASSET_LOCATIONS"),
    view: hasPermission(selectedTenant, "READ_ASSET_LOCATIONS"),
  });

  const handleSingleDelete = (selected) => {
    dispatch(deleteAssetLocation(selected.assetLocationId));
  };

  const handleExportAllButtonClick = () => {
    setExportAllLoading(true);
    const exportName = "export-asset-location";
    let options = {
      url: "/api/web/asset-locations/export",
      method: "GET",
      responseType: "blob", // important\
      withCredentials: true,
      headers: {
        Accept: "application/vnd.handson.rfid.v5+json",
      },
    };

    options = {
      ...options,
      params: {
        searchText: searchText,
      },
    };
    exportRequest(options, setExportAllLoading, exportName);
  };

  const {
    DataTable,
    hasSelected,
    currentPage,
    pageSize,
    selectedRow,
    sortOrder,
    sortField,
    searchFormHelperHandler,
  } = useDataTable({
    columns,
    source: "assetLocation",
    dataSource: assetLocations,
    updateEntityPath: "update-assetLocation",
    customActionView:
      allowPermission.edit || allowPermission.delete || allowPermission.view
        ? AssetLocationActionView
        : "",
    searchText,
    loading: loading,
    handleSingleDelete,
    allowPermission,
    setSortedInfo,
    title:
      language?.ASSET_LOCATION?.value ?? englishLang?.ASSET_LOCATION?.value,
  });

  const [ResultNotifier, isLoading] = useNotification(error, requestStatus);

  useEffect(() => {
    dispatch(
      fetchAssetLocation({
        page: searchFormHelperHandler(),
        size: pageSize,
        searchText: searchText,
        sort: sortedInfo.columnKey
          ? sortedInfo.columnKey +
            "," +
            (sortedInfo.order == "ascend" ? "ASC" : "DESC")
          : null,
      })
    );
  }, [currentPage, isLoading, searchText, sortedInfo]);

  useEffect(() => {
    setDataTable(DataTable);
  }, [loading, selectedRow, language]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({
      ...searchText,
      [dataIndex]: selectedKeys[0],
    });
  };

  let flattenedData = [];

  if (Object.keys(assetLocations).length !== 0) {
    flattenedData = Object.values(assetLocations.content);
  }

  useEffect(() => {
    if (allAssetLocation && Object.keys(allAssetLocation).length !== 0) {
      setFlattenedAllData(Object.values(allAssetLocation.content));
    }
  }, [allAssetLocation]);

  const headers = [
    {
      label: language?.LOCATION?.value ?? englishLang?.LOCATION?.value,
      key: "name",
    },
  ];

  const addNewPath = hasPermission(selectedTenant, "CREATE_ASSET_LOCATIONS")
    ? "add-assetLocation"
    : "";

  return (
    <>
      <div style={{ padding: 24, background: "#fff", minHeight: 20 }}>
        <Header
          addNewPath={addNewPath}
          hasSelected={hasSelected}
          addNewText={
            language?.ADD_ASSET_LOCATION?.value ??
            englishLang?.ADD_ASSET_LOCATION?.value
          }
          exportTableTitle={
            language?.ASSET_LOCATION?.value ??
            englishLang?.ASSET_LOCATION?.value
          }
          csvData={flattenedData}
          csvHeaders={headers}
          csvAllData={flattenedAllData}
          loading={loading}
          handleSearch={setSearchText}
          title={
            language?.ASSET_LOCATIONS?.value ??
            englishLang?.ASSET_LOCATIONS?.value
          }
          exportButton={true}
          exportAllButton={true}
          exportAllButtonClick={handleExportAllButtonClick}
          exportAllLoading={exportAllLoading}
          tooltipText={
            language?.TOOLTIP_SEARCH_NAME?.value ??
            englishLang?.TOOLTIP_SEARCH_NAME?.value
          }
        />
        {dataTable}
        <ResultNotifier />
      </div>
    </>
  );
};

export default AssetLocation;
